/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 7/8/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').service('BreadcrumbService', function () {
	var self = this;

	var breadcrumbs = [];

	self.editService = null;

	self.addBreadcrumb = function (breadcrumb) {
		breadcrumbs.push(breadcrumb);
	};

	self.removeBreadcrumbs = function () {
		angular.forEach(breadcrumbs, function (breadcrumb, index) {
			var startIndex = breadcrumbs.length - 1;
			if (breadcrumbs[startIndex].name !== breadcrumb.name) {
				breadcrumbs.splice(startIndex, breadcrumbs.length - (index + 1));
			}
		});

		return breadcrumbs;
	};

	self.getBreadcrumbs = function () {
		return breadcrumbs;
	};

	self.clearBreadcrumbs = function () {
		breadcrumbs.splice(0, breadcrumbs.length);
	};

	self.updateBreadcrumbs = function (breadcrumb) {
		if (breadcrumb && (breadcrumbs.length === 0 || breadcrumbs[breadcrumbs.length - 1].name !== breadcrumb.name)) {
			self.addBreadcrumb(breadcrumb);
		}
	};
});
